import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import ListOpenTrades from "src/features/player/components/listOpenTrades/ListOpenTrades";

const OpenTrades = () => {
  return (
    // <HomeWrapper>
    <>
      <Helmet>
        <title>Opened Trades</title>
      </Helmet>
      <Box mx={5}>
        <Typography variant="h2" mb={3}>Open Trades</Typography>
        <ListOpenTrades />
      </Box>
    </>
  );
};

export default OpenTrades;
